// modals/BulkImportModal.tsx

import React, { useState, useMemo } from "react";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { AdminGlobalTable } from "../../../../tables/AdminGlobalTable";
import MaterialModal from "../../../../app/material-modal";
import { parseCSVFile } from "../services/inviteUserService"; // (already created earlier)

export function BulkImportModal({ open, handleClose, setInviteList }) {
  const [fileName, setFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const theme = useTheme();
  const fileReader = new FileReader();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      fileReader.onload = (event) => {
        const text = event.target.result;
        const parsedData = parseCSVFile(text);
        setCsvData(parsedData);
      };
      fileReader.readAsText(file);
    }
  };

  const bulkImportCol = useMemo(() => [
    { header: "Team Number", accessorKey: "Team Number" },
    { header: "Team Name", accessorKey: "Team Name" },
    { header: "IW Team Name", accessorKey: "IW Team Name" },
    { header: "First Name", accessorKey: "First Name" },
    { header: "Last Name", accessorKey: "Last Name" },
    { header: "Email", accessorKey: "Email" },
    { header: "Role", accessorKey: "Role" },
    { header: "Instructions", accessorKey: "Instructions " },
  ], []);

  const importDataToInviteUser = () => {
    const inviteUserData = csvData.map(data => ({
      _id: uuidv4(),
      first: data["First Name"],
      last: data["Last Name"],
      email: data.Email,
      productID: '',
      roles: [{ id: uuidv4(), groupID: '', roleName: '', groupName: '' }],
    }));

    setInviteList(prev => ({
      ...prev,
      data: [...(prev?.data || []), ...inviteUserData],
      status: prev?.status || "",
      startDate: prev?.startDate || "",
      selectedInvoiceSeats: prev?.selectedInvoiceSeats || {},
    }));

    handleClose();
  };

  return (
    <MaterialModal
      open={open}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            minHeight: "700px",
            minWidth: "1000px",
            ".MuiDialogContent-root": { overflow: "auto" },
          },
        },
      }}
      title="Bulk Import"
    >
      <Typography variant="h6" fontWeight="bold" mb={1}>
        Upload Invitation Data
      </Typography>

      <Typography color="#8A8585" mb={1}>
        Select a CSV file with user information to batch import
      </Typography>

      <Stack direction="row" gap={2} mb={2}>
        <Button variant="contained" component="label">
          Choose File
          <input type="file" accept=".csv" hidden onChange={handleFileChange} />
        </Button>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {fileName || "No file chosen"}
        </Typography>
      </Stack>

      <AdminGlobalTable
        columns={bulkImportCol}
        data={csvData}
        config={{
          enableGlobalFilter: false,
          enableDensityToggle: false,
          enablePagination: false,
          enableTableHead: csvData.length > 0,
          muiSelectCheckboxProps: { color: "secondary" },
          localization: { noRecordsToDisplay: "" },
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 500px)",
              minHeight: "calc(100vh - 500px)",
            },
          },
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
        <Button variant="contained" onClick={handleClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={importDataToInviteUser}>
          Import
        </Button>
      </Box>
    </MaterialModal>
  );
}
